import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react'
import { useDiasDaGrade, AvisoDiasDaGrade } from '../../components/GradeHoraria'
import { useNavigate } from 'react-router-dom'
import {
    clssInfo,
    GetAttendanceFinalized,
    Attendance,
    updateAttendance,
    DestroyAttendance,
    getIstQuarter,
    getIIndQuarter,
    getIIIrdQuarter,
    getIVthQuarter,
    getSchoolYear,
    getSchoolDays,
    checkClassSchedule
} from '../../Api'
import { SlActionUndo } from 'react-icons/sl'
import { FiCalendar, FiEdit2, /*FiCheck, FiX*/ } from 'react-icons/fi'
import {
    Container,
    ContainerDivs,
    ContainerStudent,
    Header,
    BackButton,
    HeaderInfo,
    Title,
    Subtitle,
    DateCard,
    DateField,
    Toolbar,
    DateBadge,
    ProgressWrap,
    ProgressTrack,
    ProgressFill,
    ProgressText,
    Btt02,
    GhostButton,
    FinalizeButton,
    DangerButton,
    //DivButton,
    MarkAllBar,
    List,
    SectionLabel,
    Emp,
    StudentName,
    StatusGroup,
    StatusOption,
    ListChecked,
    CheckedItem,
    SpanChecked,
    CheckedActions,
    StatusPill,
    EditIconButton,
    EditContainer,
    //ExcludeToggle,
    BoxButtonEdit,
    Notice,
    SkeletonItem,
    ToGoBack,
    SignMessageButtonText,
    SignMessageButtonTextBold
} from './style'

// ── helpers fora do componente ─────────────────────────────────────
const safeParse = (raw) => {
    try { return raw ? JSON.parse(raw) : null } catch { return null }
}
const sameId = (a, b) => String(a) === String(b)

const normalizeString = (str) =>
    String(str || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^\w\s]/gi, '')
        .toUpperCase()

const byName = (a, b) => normalizeString(a).localeCompare(normalizeString(b))

const pad2 = (n) => String(n).padStart(2, '0')

// rótulo legível do status
//const STATUS_LABEL = { P: 'Presença', F: 'Falta', FJ: 'Falta justificada', '-': 'Não adicionar' }

const IndexAttendance = () => {
    const navigate = useNavigate()
    const mountedRef = useRef(true)

    const [open, setOpen] = useState('aberto')
    const [id_class, setId_class] = useState('')
    const [id_teacher, setId_teacher] = useState('')
    const [classStudents, setClassStudents] = useState([])  // alunos da turma (estável; não muda ao editar)
    const [rawAttendance, setRawAttendance] = useState([])  // registros crus de frequência do dia
    const [selectedDate, setSelectedDate] = useState('')
    const [day, setDay] = useState('')
    const [month, setMonth] = useState('')
    const [year, setYear] = useState('')
    const [namestudent, setNamestudent] = useState(null)
    const [editingStudent, setEditingStudent] = useState(null)
    const [editingStatus, setEditingStatus] = useState('')
    const [loading, setLoading] = useState(false)
    const [loadingList, setLoadingList] = useState(false)
    const [savingAction, setSavingAction] = useState(false)

    const [excludedStudents, setExcludedStudents] = useState([])
    const [attendanceList, setAttendanceList] = useState([])
    const [removeAttendanceList, setRemoveAttendanceList] = useState([])

    const [RegentTeacher, setRegentTeacher] = useState('')
    const [RegentTeacher02, setRegentTeacher02] = useState('')
    const [physicalEducation, setPhysicalEducation] = useState('')

    const [schoolDays, setSchoolDays] = useState([])
    const [isValidSchoolDay, setIsValidSchoolDay] = useState(true)
    const [foraDaGrade, setForaDaGrade] = useState(null) // msg quando o horário da turma não tem aula do professor no dia
    const [tempDate, setTempDate] = useState('')
    // grade horária: só os dias em que o professor tem aula nesta turma (+ sábados letivos)
    const gradeDias = useDiasDaGrade(id_class, id_teacher)
    const foraDaGradeTemp = tempDate && !gradeDias.permitido(tempDate) ? gradeDias.mensagem(tempDate) : ''

    useEffect(() => {
        mountedRef.current = true
        return () => { mountedRef.current = false }
    }, [])

    // Busca SOMENTE as frequências do dia (a única coisa que muda ao editar/finalizar/apagar).
    // Não toca em turma nem em quarters — esses já estão em memória.
    const fetchAttendance = useCallback(async () => {
        if (!day || !month || !year || !id_class || !id_teacher) return
        const teacherToUse = sameId(RegentTeacher02, id_teacher) ? RegentTeacher : id_teacher
        try {
            const resAtt = await GetAttendanceFinalized(month, year, day, id_class, teacherToUse)
            if (!mountedRef.current) return
            setRawAttendance(resAtt?.data?.data || [])
        } catch (err) {
            console.error('Erro ao buscar frequências:', err)
            if (mountedRef.current) setRawAttendance([])
        }
    }, [day, month, year, id_class, id_teacher, RegentTeacher, RegentTeacher02])

    // resolve o tipo do professor de forma centralizada e segura
    const resolveTeacherContext = useCallback(() => {
        if (!id_teacher) return null
        if (sameId(RegentTeacher, id_teacher)) {
            return { isPhysicalEducation: false, id_teacher, id_teacher02: RegentTeacher02 || null }
        }
        if (sameId(RegentTeacher02, id_teacher)) {
            return { isPhysicalEducation: false, id_teacher: RegentTeacher, id_teacher02: RegentTeacher02 }
        }
        if (sameId(physicalEducation, id_teacher)) {
            return { isPhysicalEducation: true, id_teacher, id_teacher02: null }
        }
        return null
    }, [id_teacher, RegentTeacher, RegentTeacher02, physicalEducation])

    // ── FASE 1: contexto base (professor, turma, dias letivos, data) ─
    useEffect(() => {
        (async () => {
            setLoading(true)
            try {
                const idTeacher = String(safeParse(localStorage.getItem('Id_employee')) ?? '')
                const idClass = sessionStorage.getItem('class-info')
                const sel = sessionStorage.getItem('selectedDate')
                const idSchool = safeParse(sessionStorage.getItem('id-school'))

                setId_teacher(idTeacher)
                setId_class(idClass)

                const yearRes = await getSchoolYear(idSchool)
                if (!mountedRef.current) return
                const yearValue = yearRes?.data?.data

                const schoolDaysRes = await getSchoolDays(idSchool, yearValue)
                if (!mountedRef.current) return
                setSchoolDays(schoolDaysRes?.data?.schoolDays || [])

                setRegentTeacher(safeParse(sessionStorage.getItem('classRegentTeacher')))
                setRegentTeacher02(safeParse(sessionStorage.getItem('classRegentTeacher02')))
                setPhysicalEducation(safeParse(sessionStorage.getItem('physicalEducationTeacher')))

                if (sel) {
                    setSelectedDate(sel)
                    setDay(safeParse(sessionStorage.getItem('day')))
                    setMonth(safeParse(sessionStorage.getItem('month')))
                    setYear(safeParse(sessionStorage.getItem('year')))
                }
            } catch (err) {
                console.error('Erro ao carregar contexto:', err)
            } finally {
                if (mountedRef.current) setLoading(false)
            }
        })()
    }, [])

    // persiste a data escolhida no sessionStorage
    useEffect(() => {
        if (!selectedDate) return
        sessionStorage.setItem('selectedDate', selectedDate)
        sessionStorage.setItem('day', day)
        sessionStorage.setItem('month', month)
        sessionStorage.setItem('year', year)
    }, [selectedDate, day, month, year])

    // valida se a data é um dia letivo
    useEffect(() => {
        if (!day || !month || !year || !Array.isArray(schoolDays)) return
        const selected = `${year}-${pad2(month)}-${pad2(day)}`
        setIsValidSchoolDay(schoolDays.includes(selected))
    }, [day, month, year, schoolDays])

    // grade horária da turma: só faz chamada no dia em que o professor tem aula nesta turma
    useEffect(() => {
        setForaDaGrade(null)
        if (!day || !month || !year || !id_class || !id_teacher) return
        let cancelled = false
        checkClassSchedule(id_class, id_teacher, day, month, year).then((r) => {
            if (!cancelled && r && r.permitido === false) {
                setForaDaGrade(r.msg || 'No horário desta turma não há aula sua neste dia. Entre em contato com a direção.')
            }
        })
        return () => { cancelled = true }
    }, [day, month, year, id_class, id_teacher])

    // ── DADOS PESADOS (turma + 4 quarters + status do bimestre + 1ª busca de frequências).
    // Só roda quando a DATA ou a TURMA muda — NÃO quando o professor edita/finaliza/apaga.
    // A turma e os quarters não mudam com edições, então não há motivo para buscá-los de novo. ─
    useEffect(() => {
        if (!day || !month || !year || !id_class || !id_teacher) return

        let cancelled = false
        ;(async () => {
            setLoadingList(true)
            try {
                const idSchool = safeParse(sessionStorage.getItem('id-school'))
                const teacherToUse = sameId(RegentTeacher02, id_teacher) ? RegentTeacher : id_teacher

                // tudo em paralelo, uma vez só por data/turma
                const [resAtt, resClass, q1, q2, q3, q4] = await Promise.all([
                    GetAttendanceFinalized(month, year, day, id_class, teacherToUse),
                    clssInfo(id_class),
                    getIstQuarter(year, idSchool),
                    getIIndQuarter(year, idSchool),
                    getIIIrdQuarter(year, idSchool),
                    getIVthQuarter(year, idSchool)
                ])
                if (cancelled || !mountedRef.current) return

                const classData = resClass?.data?.data?.[0]
                if (!classData) {
                    setClassStudents([]); setRawAttendance([])
                    return
                }

                // alunos da turma (estável) + frequências crus
                setClassStudents(classData.id_student || [])
                setRawAttendance(resAtt?.data?.data || [])

                // status de abertura do bimestre (reaproveita o MESMO clssInfo)
                const dateSelected = new Date(year, month - 1, day)
                const matchQuarter = (quarterData) =>
                    (quarterData?.data?.data || [])
                        .map(res => {
                            const startDate = new Date(res.startyear, res.startmonth - 1, res.startday)
                            const endDate = new Date(res.endyear, res.endmonth - 1, res.endday)
                            return (dateSelected >= startDate && dateSelected <= endDate) ? res.bimonthly : null
                        })
                        .find(Boolean)

                const found = {
                    '1º BIMESTRE': matchQuarter(q1),
                    '2º BIMESTRE': matchQuarter(q2),
                    '3º BIMESTRE': matchQuarter(q3),
                    '4º BIMESTRE': matchQuarter(q4)
                }

                if (classData.dailyStatus) {
                    const isPhysical = sameId(id_teacher, physicalEducation)
                    const pickField = (st) => isPhysical ? st.physicalEducationTeacher : st.regentTeacher
                    for (const bim of ['1º BIMESTRE', '2º BIMESTRE', '3º BIMESTRE', '4º BIMESTRE']) {
                        if (found[bim] && classData.dailyStatus[bim]) {
                            setOpen(pickField(classData.dailyStatus[bim]))
                            break
                        }
                    }
                }
            } catch (err) {
                console.error('Erro ao carregar dados:', err)
                if (!cancelled) { setClassStudents([]); setRawAttendance([]) }
            } finally {
                if (!cancelled && mountedRef.current) setLoadingList(false)
            }
        })()

        return () => { cancelled = true }
    }, [day, month, year, id_class, id_teacher, RegentTeacher, RegentTeacher02, physicalEducation])

    // ── stdt (pendentes) e checked (realizados) são DERIVADOS em memória ──
    // de classStudents + rawAttendance. Recalculam instantaneamente quando a
    // frequência muda, sem nenhuma chamada de rede. ─
    const { stdt, checked } = useMemo(() => {
        const filtered = rawAttendance.filter(item => {
            const isPE = item.isPhysicalEducation
            if (sameId(physicalEducation, id_teacher)) return isPE === true
            if (sameId(RegentTeacher, id_teacher)) return isPE === false || isPE === undefined
            return true
        })
        const realizedIds = new Set(filtered.map(r => r.id_student?._id).filter(Boolean))
        const pending = classStudents.filter(s => s && !realizedIds.has(s._id))
        return { stdt: pending, checked: filtered }
    }, [classStudents, rawAttendance, physicalEducation, id_teacher, RegentTeacher])

    // ── ações ────────────────────────────────────────────────────────
    const markAllAsPresent = useCallback(() => {
        const ctx = resolveTeacherContext()
        if (!ctx) {
            alert('Aguarde o carregamento dos dados do professor antes de continuar.')
            return
        }
        const allPresent = stdt.map(student => ({
            id_student: student._id,          // bug corrigido: era stdt._id || student._id
            status: 'P',
            day, month, year,
            id_teacher: ctx.id_teacher,
            id_teacher02: ctx.id_teacher02,
            id_class,
            isPhysicalEducation: ctx.isPhysicalEducation
        }))
        setAttendanceList(allPresent)
    }, [resolveTeacherContext, stdt, day, month, year, id_class])

    const handleCheckAttendance = useCallback((id_student, status) => {
        const ctx = resolveTeacherContext()
        if (!ctx) {
            console.error('handleCheckAttendance: tipo de professor não identificado.')
            return
        }
        setAttendanceList(prevList => {
            const existing = prevList.find(att => att.id_student === id_student)
            if (existing?.status === status) {
                return prevList.filter(att => att.id_student !== id_student)
            }
            return [
                ...prevList.filter(att => att.id_student !== id_student),
                {
                    id_student, status, day, month, year,
                    id_teacher: ctx.id_teacher,
                    id_teacher02: ctx.id_teacher02,
                    id_class,
                    isPhysicalEducation: ctx.isPhysicalEducation
                }
            ]
        })
    }, [resolveTeacherContext, day, month, year, id_class])

    const toggleExclude = useCallback((studentId) => {
        setExcludedStudents(prev =>
            prev.includes(studentId) ? prev.filter(id => id !== studentId) : [...prev, studentId])
        handleCheckAttendance(studentId, '-')
    }, [handleCheckAttendance])

    const clickRemovedate = useCallback(() => {
        sessionStorage.removeItem('selectedDate')
        sessionStorage.removeItem('day')
        sessionStorage.removeItem('month')
        sessionStorage.removeItem('year')
        setSelectedDate('')
        setDay(''); setMonth(''); setYear('')
        setAttendanceList([])
        setExcludedStudents([])
    }, [])

    const Finalyze = useCallback(async () => {
        if (savingAction) return
        setSavingAction(true)
        try {
            await Attendance(attendanceList)
            if (!mountedRef.current) return
            setAttendanceList([])
            setExcludedStudents([])
            await fetchAttendance()   // re-busca SÓ as frequências (turma/quarters já em memória)
        } catch (err) {
            console.error('Erro ao finalizar chamada:', err)
        } finally {
            if (mountedRef.current) setSavingAction(false)
        }
    }, [savingAction, attendanceList, fetchAttendance])

    const startEditing = useCallback((checkedStdt) => {
        setEditingStudent(checkedStdt._id)
        setEditingStatus(checkedStdt.status || '')   // inicia com a frequência atual
        setNamestudent(checkedStdt)
    }, [])

    const saveEdit = useCallback(async () => {
        if (savingAction) return
        const editedId = editingStudent
        const newStatus = editingStatus
        // update otimista: reflete na hora, sem esperar a rede
        setRawAttendance(prev => prev.map(r =>
            r._id === editedId ? { ...r, status: newStatus } : r))
        setEditingStudent(null)
        setNamestudent(null)
        setSavingAction(true)
        try {
            await updateAttendance(editedId, newStatus)
            if (!mountedRef.current) return
            await fetchAttendance()   // confirma com o servidor (só frequências)
        } catch (err) {
            console.error('Erro ao editar frequência:', err)
            if (mountedRef.current) await fetchAttendance()  // rollback: volta ao estado real
        } finally {
            if (mountedRef.current) setSavingAction(false)
        }
    }, [savingAction, editingStudent, editingStatus, fetchAttendance])

    const handleDestroy = useCallback((list) => {
        setRemoveAttendanceList(list.map(s => s._id))
    }, [])

    const Destroy = useCallback(async () => {
        if (savingAction) return
        setSavingAction(true)
        try {
            await DestroyAttendance(removeAttendanceList)
            if (!mountedRef.current) return
            setRemoveAttendanceList([])
            await fetchAttendance()   // re-busca SÓ as frequências
        } catch (err) {
            console.error('Erro ao apagar chamada:', err)
        } finally {
            if (mountedRef.current) setSavingAction(false)
        }
    }, [savingAction, removeAttendanceList, fetchAttendance])

    const Return = useCallback(() => navigate(-1), [navigate])

    // ── derivados memoizados ─────────────────────────────────────────
    const sortedPending = useMemo(
        () => stdt.slice().sort((a, b) => byName(a.name, b.name)),
        [stdt]
    )
    const sortedChecked = useMemo(
        () => checked.slice().sort((a, b) => byName(a.id_student.name, b.id_student.name)),
        [checked]
    )
    const allStudentsMarked = useMemo(
        () => stdt.length > 0 && stdt.every(s => attendanceList.some(att => att.id_student === s._id)),
        [stdt, attendanceList]
    )
    const markedCount = useMemo(
        () => stdt.filter(s => attendanceList.some(att => att.id_student === s._id)).length,
        [stdt, attendanceList]
    )
    const pct = stdt.length > 0 ? Math.round((markedCount / stdt.length) * 100) : 0

    // ── dia não letivo ───────────────────────────────────────────────
    if (selectedDate && !isValidSchoolDay) {
        return (
            <Container>
                <ContainerDivs>
                    <Notice $tone="danger">
                        <h2>Dia não letivo</h2>
                        <p>A data {pad2(day)}/{pad2(month)}/{year} não está no calendário letivo. Selecione outra data para registrar a frequência.</p>
                        <Btt02 onClick={clickRemovedate}>Selecionar outra data</Btt02>
                    </Notice>
                    <ToGoBack onClick={Return} role="button" tabIndex={0}>
                        <SignMessageButtonText>Voltar para a</SignMessageButtonText>
                        <SignMessageButtonTextBold>Turma</SignMessageButtonTextBold>
                    </ToGoBack>
                </ContainerDivs>
            </Container>
        )
    }

    // ── fora do horário da turma ─────────────────────────────────────
    if (selectedDate && foraDaGrade) {
        return (
            <Container>
                <ContainerDivs>
                    <Notice $tone="danger">
                        <h2>Sem aula neste dia</h2>
                        <p>{foraDaGrade}</p>
                        <Btt02 onClick={clickRemovedate}>Selecionar outra data</Btt02>
                    </Notice>
                    <ToGoBack onClick={Return} role="button" tabIndex={0}>
                        <SignMessageButtonText>Voltar para a</SignMessageButtonText>
                        <SignMessageButtonTextBold>Turma</SignMessageButtonTextBold>
                    </ToGoBack>
                </ContainerDivs>
            </Container>
        )
    }

    // ── loading inicial ──────────────────────────────────────────────
    if (loading) {
        return (
            <Container>
                <ContainerDivs>
                    <Header>
                        <HeaderInfo><Title>Frequência</Title></HeaderInfo>
                    </Header>
                    <List>{[...Array(5)].map((_, i) => <SkeletonItem key={i} />)}</List>
                </ContainerDivs>
            </Container>
        )
    }

    return (
        <Container>
            <ContainerDivs>
                {/* SELEÇÃO DE DATA */}
                {!selectedDate && (
                    <>
                        <Header>
                            <BackButton onClick={Return} aria-label="Voltar"><SlActionUndo size={20} /></BackButton>
                            <HeaderInfo><Title>Frequência</Title><Subtitle>Selecione a data da chamada</Subtitle></HeaderInfo>
                        </Header>
                        <DateCard>
                            <h3>Qual a data da chamada?</h3>
                            <DateField
                                type="date"
                                value={tempDate}
                                onChange={(e) => setTempDate(e.target.value)}
                                aria-label="Data da chamada"
                            />
                            {foraDaGradeTemp && (
                                <div role="alert" style={{ background: '#fde8e8', border: '1px solid #dc2626', color: '#991b1b', borderRadius: 10, padding: '8px 12px', fontSize: 13.5, margin: '8px 0' }}>
                                    ⚠️ {foraDaGradeTemp}
                                </div>
                            )}
                            <AvisoDiasDaGrade grade={gradeDias} />
                            <Btt02
                                disabled={!tempDate || !!foraDaGradeTemp}
                                onClick={() => {
                                    if (!tempDate || foraDaGradeTemp) return
                                    const [y, m, d] = tempDate.split('-')
                                    setSelectedDate(tempDate)
                                    setDay(Number(d)); setMonth(Number(m)); setYear(Number(y))
                                }}
                            >
                                Confirmar data
                            </Btt02>
                        </DateCard>
                    </>
                )}

                {/* CHAMADA */}
                {selectedDate && !editingStudent && removeAttendanceList.length === 0 && (
                    open === 'aberto' ? (
                        <ContainerStudent>
                            <Header>
                                <BackButton onClick={Return} aria-label="Voltar"><SlActionUndo size={20} /></BackButton>
                                <HeaderInfo><Title>Frequência</Title><Subtitle>Chamada do dia</Subtitle></HeaderInfo>
                            </Header>

                            <Toolbar>
                                <DateBadge><FiCalendar size={16} /> {pad2(day)}/{pad2(month)}/{year}</DateBadge>
                                <GhostButton onClick={clickRemovedate} disabled={savingAction}>Trocar data</GhostButton>
                            </Toolbar>

                            {loadingList && (
                                <List>{[...Array(6)].map((_, i) => <SkeletonItem key={i} />)}</List>
                            )}

                            {/* PENDENTES (a marcar) */}
                            {!loadingList && sortedPending.length > 0 && (
                                <>
                                    <MarkAllBar>
                                        Marcar todos como presença
                                        <input
                                            type="checkbox"
                                            onChange={(e) => e.target.checked ? markAllAsPresent() : setAttendanceList([])}
                                        />
                                    </MarkAllBar>

                                    {stdt.length > 0 && (
                                        <ProgressWrap>
                                            <ProgressTrack><ProgressFill $pct={pct} /></ProgressTrack>
                                            <ProgressText>{markedCount} de {stdt.length} alunos marcados</ProgressText>
                                        </ProgressWrap>
                                    )}

                                    <List>
                                        {sortedPending.map(student => {
                                            const att = attendanceList.find(a => a.id_student === student._id)
                                            const status = att?.status
                                            const excluded = excludedStudents.includes(student._id)
                                            return (
                                                <Emp key={student._id}>
                                                    <StudentName>{student.name}</StudentName>
                                                    <StatusGroup>
                                                        <StatusOption
                                                            $variant="P" $active={status === 'P'}
                                                            disabled={excluded}
                                                            onClick={() => handleCheckAttendance(student._id, 'P')}
                                                        ><span>✓</span><small>Presença</small></StatusOption>
                                                        <StatusOption
                                                            $variant="F" $active={status === 'F'}
                                                            disabled={excluded}
                                                            onClick={() => handleCheckAttendance(student._id, 'F')}
                                                        ><span>✕</span><small>Falta</small></StatusOption>
                                                        <StatusOption
                                                            $variant="FJ" $active={status === 'FJ'}
                                                            disabled={excluded}
                                                            onClick={() => handleCheckAttendance(student._id, 'FJ')}
                                                        ><span>FJ</span><small>Justificada</small></StatusOption>
                                                        <StatusOption
                                                            $variant="-" $active={excluded}
                                                            onClick={() => toggleExclude(student._id)}
                                                        ><span>—</span><small>Não adicionar</small></StatusOption>
                                                    </StatusGroup>
                                                </Emp>
                                            )
                                        })}
                                    </List>

                                    <FinalizeButton onClick={Finalyze} disabled={!allStudentsMarked || savingAction}>
                                        {savingAction ? 'Salvando...' : 'Finalizar chamada'}
                                    </FinalizeButton>
                                    {!allStudentsMarked && (
                                        <ProgressText style={{ textAlign: 'center', color: '#c0392b' }}>
                                            Todos os alunos precisam de um status antes de finalizar.
                                        </ProgressText>
                                    )}
                                </>
                            )}

                            {/* FINALIZADAS */}
                            {!loadingList && sortedChecked.length > 0 && (
                                <>
                                    <SectionLabel>Chamada registrada</SectionLabel>
                                    <ListChecked>
                                        {sortedChecked.map(c => (
                                            <CheckedItem key={c._id}>
                                                <SpanChecked>{c.id_student.name}</SpanChecked>
                                                <CheckedActions>
                                                    <StatusPill $status={c.status}>{c.status}</StatusPill>
                                                    <EditIconButton onClick={() => startEditing(c)}>
                                                        <FiEdit2 size={14} /> Editar
                                                    </EditIconButton>
                                                </CheckedActions>
                                            </CheckedItem>
                                        ))}
                                        <DangerButton onClick={() => handleDestroy(checked)}>
                                            Apagar chamada deste dia
                                        </DangerButton>
                                    </ListChecked>
                                </>
                            )}

                            <ToGoBack onClick={Return} role="button" tabIndex={0}>
                                <SignMessageButtonText>Voltar para a</SignMessageButtonText>
                                <SignMessageButtonTextBold>Turma</SignMessageButtonTextBold>
                            </ToGoBack>
                        </ContainerStudent>
                    ) : (
                        <>
                            <Notice>
                                <h3>Bimestre fechado</h3>
                                <p>Para editar a frequência deste período, contate o Diretor ou Supervisor.</p>
                                <Btt02 onClick={clickRemovedate}>Selecionar outra data</Btt02>
                            </Notice>
                            <ToGoBack onClick={Return} role="button" tabIndex={0}>
                                <SignMessageButtonText>Voltar para a</SignMessageButtonText>
                                <SignMessageButtonTextBold>Turma</SignMessageButtonTextBold>
                            </ToGoBack>
                        </>
                    )
                )}

                {/* EDIÇÃO */}
                {editingStudent && namestudent && (
                    <EditContainer>
                        <h3>Editando frequência de {namestudent.id_student.name}</h3>
                        <select
                            value={editingStatus}
                            onChange={(e) => setEditingStatus(e.target.value)}
                        >
                            <option value="">Selecione</option>
                            <option value="P">Presença</option>
                            <option value="F">Falta</option>
                            <option value="FJ">Falta justificada (atestado)</option>
                            <option value="-">Não adicionar</option>
                        </select>
                        <BoxButtonEdit>
                            <Btt02 onClick={saveEdit} disabled={savingAction}>
                                {savingAction ? 'Salvando...' : 'Salvar'}
                            </Btt02>
                            <GhostButton onClick={() => { setEditingStudent(null); setNamestudent(null) }}>
                                Cancelar
                            </GhostButton>
                        </BoxButtonEdit>
                    </EditContainer>
                )}

                {/* CONFIRMAÇÃO DE EXCLUSÃO */}
                {removeAttendanceList.length > 0 && (
                    <EditContainer>
                        <h3>Apagar a chamada deste dia?</h3>
                        <ProgressText>Esta ação não pode ser desfeita.</ProgressText>
                        <BoxButtonEdit>
                            <DangerButton onClick={Destroy} disabled={savingAction}>
                                {savingAction ? 'Apagando...' : 'Apagar'}
                            </DangerButton>
                            <GhostButton onClick={() => setRemoveAttendanceList([])}>Cancelar</GhostButton>
                        </BoxButtonEdit>
                    </EditContainer>
                )}
            </ContainerDivs>
        </Container>
    )
}

export default IndexAttendance